import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';

interface PairDeviceLinkV2Props {
    onRetry: () => void;
}

export const PairDeviceLinkV2 = ({ onRetry }: PairDeviceLinkV2Props) => {
    return (
        <>
            <div className="modal-body">
                <h2 className="text-primary">Setup Connection</h2>
                <p>Unable to connect to DeviceLink, this can be caused by the software not being installed or running.</p>
                <ol className="posh-list">
                    <li>Download and run the DeviceLink setup:
                        <br />
                        <br />
                        <a className="btn btn-primary" href="https://devicelink.vitalograph-clinical.info/setup.exe">
                            <FontAwesomeIcon icon={faDownload} aria-hidden="true" />&nbsp;
                            DeviceLink Setup
                        </a>
                    </li>
                </ol>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onRetry}>Retry</button>
            </div>
        </>
    );
}
